import { Component, Input, OnInit } from '@angular/core';
import { ControlContainer, NgForm } from '@angular/forms';
import { JobPosting } from '@app/models/recruiting/job-posting.model';
import { JobPostingCompensationTypeLabelsLabelsMap } from '@app/modules/applicant-tracker/constants/job-posting-compensation-type-labels-map.constant';
import { JobPostingCompensationTypes } from '@app/modules/applicant-tracker/enums/job-posting-compensation-types.enum';
import { JobPostingCompensationTypeLabels } from '@app/modules/applicant-tracker/interfaces/job-posting-compensation-type-labels.interface';

@Component({
    selector: 'app-compensation-type-select',
    templateUrl: './compensation-type-select.template.html',
    styleUrls: ['./compensation-type-select.style.scss'],
    viewProviders: [{ provide: ControlContainer, useExisting: NgForm }],
})
export class CompensationTypeSelectComponent implements OnInit {
    @Input() jobPosting: JobPosting;

    compensationTypes: JobPostingCompensationTypeLabels[];

    ngOnInit() {
        const rawCompensationTypes = Object.values(JobPostingCompensationTypes);
        this.compensationTypes = rawCompensationTypes.map((rawEnum: string) => {
            return { value: rawEnum, label: JobPostingCompensationTypeLabelsLabelsMap[rawEnum] };
        });
    }
}
